import React from "react";
import { connect } from "react-redux";
import { getDecodedUser } from "../utils/login";
import { isEmpty } from "lodash";

const AUTH_NAME_LABELS = {
  officialAdmin: "ADMINISTRÁTOR",
  admin: "SPRÁVCE",
  judge: "SOUDCE",
  ovm: "PODPŮRNÝ ORGÁN",
  legitimate: "OPRÁVNĚNÝ ORGÁN",
  official: "VEŘEJNÝ FUNKCIONÁŘ",
  publicLogged: "VEŘEJNOST",
  internal: "INTERNÍ UŽIVATEL",
};

const ROLE_LABELS = {
  ROLE_OFFICIAL: "VEŘEJNÝ FUNKCIONÁŘ",
  ROLE_PUBLIC: "VEŘEJNOST",
  ROLE_OVM: "PODPŮRNÝ ORGÁN",
  ROLE_LEGITIMATE: "OPRÁVNĚNÝ ORGÁN",
  ROLE_INTERNAL_OFFICIAL_ADMIN: "ADMINISTRÁTOR",
  ROLE_INTERNAL_ADMIN: "SPRÁVCE",
  ROLE_INTERNAL_JUDGE: "SOUDCE",
  ROLE_INTERNAL_USER: "INTERNÍ UŽIVATEL",
  ROLE_INTERNAL: "INTERNÍ UŽIVATEL",
};

const ROLE_PRIORITY = [
  "ROLE_OFFICIAL",
  "ROLE_PUBLIC",
  "ROLE_OVM",
  "ROLE_LEGITIMATE",
  "ROLE_INTERNAL_OFFICIAL_ADMIN",
  "ROLE_INTERNAL_ADMIN",
  "ROLE_INTERNAL_JUDGE",
  "ROLE_INTERNAL_USER",
  "ROLE_INTERNAL",
];

const getPrimaryRoleLabel = (roles = []) => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return "PŘIHLÁŠENÝ UŽIVATEL";
  }

  const primaryRole = ROLE_PRIORITY.find((role) => roles.includes(role));

  if (!primaryRole) {
    return "PŘIHLÁŠENÝ UŽIVATEL";
  }

  return ROLE_LABELS[primaryRole] || "PŘIHLÁŠENÝ UŽIVATEL";
};

const LoggedUser = ({ onLogout, auth }) => {
  const user = getDecodedUser();

  if (isEmpty(user)) {
    return null;
  }

  const handleLogout = (e) => {
    e.preventDefault();
    onLogout();
  };

  const roleLabel =
    (auth?.name && AUTH_NAME_LABELS[auth.name]) ||
    getPrimaryRoleLabel(user.aut);

  return (
    <div className="logged-user">
      <div className="logged-user__role">{roleLabel}</div>
      <div className="logged-user__menu">
        <span>{user.name}</span>
        <span className="logged-user__separator">|</span>
        <a className="logged-user-btn" href="#logout" onClick={handleLogout}>
          Odhlásit
        </a>
      </div>
    </div>
  );
};

export default connect((state) => ({ auth: state.sidebar.auth }))(LoggedUser);
